<script setup lang="ts">
export interface LoadingSpinnerProps {
  size?: number;
}
const props = withDefaults(defineProps<LoadingSpinnerProps>(), { size: 45 });
</script>

<template>
  <div class="spinner" :style="{ fontSize: `${props.size}px` }">
    <div v-for="index in 8" :key="index" class="spinner-blade" />
  </div>
</template>

<style>
.spinner {
  position: relative;
  display: inline-block;
  width: 1em;
  height: 1em;
}

.spinner-blade {
  position: absolute;
  bottom: 0;
  width: 0.09em;
  height: 0.27em;
  border-radius: 0.5em;
  background-color: transparent;
  transform-origin: center -0.2222em;
  animation: spinner-fade 1s infinite linear;
}

.spinner-blade:nth-child(1) { animation-delay: -0.875s; transform: rotate(-90deg); }
.spinner-blade:nth-child(2) { animation-delay: -0.750s; transform: rotate(-45deg); }
.spinner-blade:nth-child(3) { animation-delay: -0.625s }
.spinner-blade:nth-child(4) { animation-delay: -0.5s; transform: rotate(45deg); }
.spinner-blade:nth-child(5) { animation-delay: -0.375s; transform: rotate(90deg); }
.spinner-blade:nth-child(6) { animation-delay: -0.25s; transform: rotate(135deg); }
.spinner-blade:nth-child(7) { animation-delay: -0.125s; transform: rotate(180deg); }
.spinner-blade:nth-child(8) { animation-delay: 0s; transform: rotate(225deg); }

@keyframes spinner-fade {
  0% {
    background-color: #ffffff;
  }
  100% {
    background-color: transparent;
  }
}
</style>
